import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { CSSProperties } from 'react';

export const LoadingSpinner: React.FC<{
    fontSize?: number;
    style?: CSSProperties;
}> = ({ fontSize = 20, style }) => {
    return (
        <Spin
            className="text-primary"
            indicator={
                <LoadingOutlined
                    style={{ fontSize: fontSize, ...style }}
                    rev={undefined}
                    spin
                />
            }
        />
    );
};
